import { DocumentNode } from 'graphql';
import gql from 'graphql-tag';
import React from 'react';
import { StaticField } from 'rewire-ui';
import { IUdf } from '../DataTypes';
import { guardedQuery } from '../graphql/GraphQLClient';
import { createExpressionEditor } from '../settings/ExpressionEditor';
import udfsSubscriptionService from '../services/UdfsSubscriptionService';

const getUdfsQuery: DocumentNode = gql`
  query($ids: [ID!]!, $fields: [String!]!) {
    employeesByIds(ids: $ids) {
      udfs(fields: $fields)
    }
  }
`;

export function UdfValue(props: {
  value: any;
  field: string;
  label?: string;
  className?: string;
  classes?: any;
  style?: React.CSSProperties;
}) {
  const [value, setValue] = React.useState<any>('evaluating...');

  React.useEffect(() => {
    if (!props?.value?.id) {
      setValue('');
      return;
    }
    try {
      guardedQuery(getUdfsQuery, { ids: [props.value.id], fields: [props.field] })
        .then((res: any) => {
          const result = res.data?.employeesByIds?.[0]?.udfs[props.field]?.value;
          setValue(result ?? '');
        })
        .catch(() => {
          setValue('unavailable');
        });
    } catch (_) {
      setValue('unavailable');
    }
  }, []);

  return <StaticField {...(props as any)} label={props.label} value={value} />;
}

export function createUdfExpressionField(form: any, udf: IUdf) {
  return (props: any) => {
    return <UdfValue {...props} value={form.value} field={udf.name} label={udf.displayName} />;
  };
}

function _convertUdfsTo(text: unknown, sourceProperty: keyof IUdf, destinationProperty: keyof IUdf) {
  if (!text || typeof text !== 'string') return text;
  const match = /\.udf\(\s*("|')((?:\\\1|(?:(?!\1).))*)\1\s*\)/g;
  let _udfs: IUdf[];

  function udfs() {
    if (!_udfs) {
      _udfs = udfsSubscriptionService.subscriptionModel.getUdfsByDocumentType('employees') ?? [];
    }
    return _udfs;
  }

  const result = text.replace(match, (m, p1, p2, _offset, _str) => {
    const udf: IUdf | undefined = udfs().find((udf) => udf[sourceProperty] === p2);
    if (udf) return `.udf('${udf[destinationProperty]}')`;
    return m;
  });
  return result;
}

export const convertUdfsToId = (text: unknown) => _convertUdfsTo(text, 'displayName', 'name');
export const convertUdfsToName = (text: unknown) => _convertUdfsTo(text, 'name', 'displayName');

// function convertUdfsDisplayNamesToNames(value: string) {
//   const udfs = udfsSubscriptionService.subscriptionModel.getUdfsByDocumentType('employees');
//   return convertUdfsToId(udfs ?? [], value);
// }

export const ExpressionEditor = createExpressionEditor(['udf-expression']);

export function createUdfExpressionEditor() {
  return (props: any) => {
    const [show, setShow] = React.useState(false);
    const disabled = props.disabled ?? false;
    if (disabled) {
      return (
        <span
          title="only supported on employee UDFs"
          style={{
            textOverflow: 'ellipsis',
            fontStyle: 'italic',
            color: 'gray',
            display: 'block',
            overflow: 'hidden',
            whiteSpace: 'nowrap',
          }}
        >
          only supported on employee UDFs
        </span>
      );
    }
    if (show) {
      return (
        <ExpressionEditor
          field={props}
          onValueChange={(value) => {
            props.onValueChange(value);
            setShow(false);
          }}
        />
      );
    }
    return (
      <button
        type="button"
        style={{
          cursor: 'pointer',
          textAlign: 'left',

          background: 'none',
          border: 'none',
          padding: 0,
          font: 'inherit',
        }}
        onClick={() => setShow(true)}
      >
        <span
          title="click to edit"
          style={{
            textOverflow: 'ellipsis',
            textDecoration: 'underline dotted gray',
            display: 'block',
            overflow: 'hidden',
            whiteSpace: 'nowrap',
          }}
        >
          {props.value ?? 'click to edit'}
        </span>
      </button>
    );
  };
}
